module.exports = __webpack_public_path__ + "img/login_logo.02798039.png";